import styled from 'styled-components'

import Flex from 'src/components/Layout/Flex/Flex'
import { TableSpinnerWrapperProps, SearchResultWrapperProps } from './types'

export const SearchResultWrapper = styled(Flex).attrs({
  flexDirection: 'column',
  justifyContent: 'flex-start',
})<SearchResultWrapperProps>`
  width: ${props =>
    props?.removePadding ? '100%' : 'calc(100% - 16px - 16px)'};
  padding: ${props => (props?.removePadding ? '0' : '16px')};
`

export const TableSpinnerWrapper = styled(Flex)<TableSpinnerWrapperProps>`
  width: 100%;
  min-height: ${props => props.minHeight || 0}px;
`
